import { useContext, useEffect, useState } from "react"
import { ToolContext } from "../../../core/context/ToolContext";
import { env } from "../../../core/Env";
import { rqx } from "../../../core/request/API";
import { NotifProfession } from "../../../core/global/modal/Modal";
import { useLocation, useHistory } from "react-router-dom";
import { getGlobalProfession } from "../../../core/request/Global";
import { GetRandomThreeResult } from "../toolUsage/global/Format";
// import moment from "moment";

// const tool_id =  process.env.REACT_APP_TID_PSL;
// const global_id = process.env.REACT_APP_GLOBAL_ID;

export const RenderAPI = () => {
    const location = useLocation();
    const nav = useHistory()
    const { tool_state } = useContext(ToolContext)
    const { __SESSION, globalLoader, toolOwned, validateAccount, toolShuffle } = tool_state
    
    const validateProfession = async () => {
        try {
            const data = await getGlobalProfession({ aid: tool_state.__SESSION.data.ainfo.aid });
            const currentPath = window.location.pathname;
            const excludedPaths = ['/professional', '/profile'];

            if (data.length === 0 && !excludedPaths.includes(currentPath) )  {
                tool_state.openPModal.set(true);
            } else {
                tool_state.openPModal.set(false);
            }
            tool_state.pData.set({...tool_state.pData.data, id: data.length > 0 ? data[0].id: '' ,first_name: (tool_state.__SESSION.data.pinfo.length > 0 ? tool_state.__SESSION.data.pinfo[0].first_name : '') , middle_name:'', last_name: (tool_state.__SESSION.data.pinfo.length > 0 ? tool_state.__SESSION.data.pinfo[0].last_name : ''), suffix: (tool_state.__SESSION.data.pinfo.length > 0 ? tool_state.__SESSION.data.pinfo[0].suffix : ''), prc_id_expiry_date:data.length > 0 ? data[0].valid_until : null, profession:data[0]?.profession_id, prc_license:data.length > 0 ? data[0]?.prc_license_num: null });
        } catch (err) {
            console.error("Error validating profession:", err);
        }
    };

    const __init = async() => {
        await globalLoader.set(true)
        // await __runactiveuser()
       
        //GET TOOL OWNED
        let prms = {aid:__SESSION.data.ainfo.aid, platform:'personal' } 
        let resTool = await rqx.get(`<<global>>/${env()==='local'?'dev':env()}/tools/owned`, prms)
        toolOwned.set(resTool)
        console.log(resTool)
        if (resTool.length > 3) {
            const res = GetRandomThreeResult(resTool);
            toolShuffle.set(res)
        }

        await validateProfession();
        await globalLoader.set(false)
    }

    const handleProceed = () => {
		tool_state.openPModal.set(false)
    	nav.push('/professional');
	}

    const [subscribe, setSubscribe] = useState(true)

    useEffect(() => {
        if (subscribe) {
            if (globalLoader.data) {
                __init()
            }
        }
        return () => setSubscribe(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [validateAccount.data])

    useEffect(() => {
        validateProfession();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);
    
    return (
        <>
            <NotifProfession open={tool_state.openPModal.data} handleProceed={handleProceed} color="primary" />
        </>
    )
}